"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceRows = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _useGetValue = require("../../../../../hooks/useGetValue");
var _Row = require("../../Row");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const DeviceRows = _ref => {
  let {
    device = {}
  } = _ref;
  const {
    equipmentName,
    title: propTitle = '',
    equipmentType,
    thingPDIDDevice,
    building
  } = device;
  const allBuildings = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.selectBuildings) || [];
  const temperatureIds = (0, _useGetValue.useGetValueIdsByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex
  });
  const tV = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues);
  const getTranslate = (0, _paulCorePackage.useTranslationValue)();
  const getName = (0, _react.useMemo)(() => {
    if (propTitle) return propTitle;
    if (equipmentType === _paulCorePackage.constants.ComponentTypes.PwcPoe && !equipmentName) {
      var _tV$Default;
      const tPwcPoe = (tV === null || tV === void 0 || (_tV$Default = tV.Default) === null || _tV$Default === void 0 || (_tV$Default = _tV$Default.equipmentType) === null || _tV$Default === void 0 ? void 0 : _tV$Default.PwcPoe) || '';
      const buildingName = _paulCorePackage.functions.getBuildingName({
        device: {
          building
        },
        allBuildings
      });
      return "".concat(tPwcPoe, " ").concat(buildingName);
    }
    return getTranslate(equipmentName) || '';
  }, [getTranslate, tV, allBuildings, equipmentName, propTitle, equipmentType, building]);
  return (0, _react.useMemo)(() => temperatureIds.map(displayNameId => /*#__PURE__*/_react.default.createElement(_Row.Row, {
    equipmentType: equipmentType,
    key: displayNameId,
    displayNameId: displayNameId,
    thingPDIDDevice: thingPDIDDevice,
    name: getName
  })), [temperatureIds, thingPDIDDevice, getName, equipmentType]);
};
exports.DeviceRows = DeviceRows;